import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { FaHome, FaBoxOpen, FaClipboardList, FaUserTie } from "react-icons/fa";
import "./Header.css";
import logo from "../assets/aita-logo.png";

const navLinks = [
  { to: "/", label: "Inicio" },
  { to: "/estado-cuenta", label: "Iniciar sesión" },
  { to: "/asesores", label: "Asesores de venta" },
  { to: "/productos", label: "Catálogo de productos" },
  { to: "/catalogo", label: "Catálogo ofertas" },
  { to: "/catalogo-motos", label: "Catálogo de motos" },
];

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="aita-header-wrapper aita-header-background">
      {/* BARRA CON LOGO */}
      <div className="aita-header-banner">
        <Link to="/" className="aita-header-logo-link" onClick={closeMenu}>
          <img src={logo} alt="Logo AITA" className="aita-header-logo-img" />
        </Link>
      </div>

      {/* BARRA DE NAVEGACIÓN */}
      <header className="aita-header-main">
        <div className="aita-header-main-inner">
          <button
            className="aita-header-menu-button"
            onClick={toggleMenu}
            aria-label="Abrir menú"
          >
            ☰
          </button>

          <nav className="aita-header-nav">
            {navLinks.map((link) => (
              <Link key={link.to} to={link.to} className="aita-header-nav-link">
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="aita-header-cta-wrapper">
            <Link to="/estado-cuenta" className="aita-header-cta">
              Consulta tu crédito
            </Link>
          </div>
        </div>
      </header>

      {/* MENÚ LATERAL */}
      <div className={`aita-header-side-menu ${isOpen ? "aita-header-side-menu-open" : ""}`}>
        <button className="aita-header-close-button" onClick={toggleMenu} aria-label="Cerrar menú">
          <AiOutlineClose />
        </button>

        <ul className="aita-header-side-list">
          <li><Link to="/" onClick={closeMenu}><FaHome /><span>Inicio</span></Link></li>
          <li><Link to="/estado-cuenta" onClick={closeMenu}><FaClipboardList /><span>Iniciar sesión</span></Link></li>
          <li><Link to="/asesores" onClick={closeMenu}><FaUserTie /><span>Asesores de venta</span></Link></li>
          <li><Link to="/productos" onClick={closeMenu}><FaBoxOpen /><span>Catálogo de productos</span></Link></li>
          <li><Link to="/catalogo" onClick={closeMenu}><FaClipboardList /><span>Catálogo ofertas</span></Link></li>
          <li><Link to="/catalogo-motos" onClick={closeMenu}><FaClipboardList /><span>Catálogo de motos</span></Link></li>
        </ul>
      </div>

      {isOpen && <div className="aita-header-backdrop" onClick={closeMenu} />}
    </div>
  );
};
